//created by sudip
import {
  Search,
  Workflow,
  Link2,
  Bot,
  TrendingUp,
} from "lucide-react";
import { Container } from "@/components/common/Container";
import {Section} from "@/components/common/Section";
import {SectionHeading} from "@/components/common/SectionHeading";

const steps = [
  {
    icon: Search,
    title: "Understand",
    description:
      "Analyse existing business processes, stakeholders and operational challenges unique to your industry.",
  },
  {
    icon: Workflow,
    title: "Digitalise",
    description:
      "Replace manual, paper-based and disconnected workflows with modern digital processes.",
  },
  {
    icon: Link2,
    title: "Integrate",
    description:
      "Connect ERP, CRM, finance and third-party platforms into one intelligent ecosystem.",
  },
  {
    icon: Bot,
    title: "Automate",
    description:
      "Deploy AI agents, workflow automation and business rules to reduce repetitive work.",
  },
  {
    icon: TrendingUp,
    title: "Optimise",
    description:
      "Continuously improve operations using dashboards, analytics and predictive insights.",
  },
];

export default function IndustryTransformation() {
  return (
    <Section spacing="compact">
      <Container>
        <SectionHeading
          eyebrow="Transformation Journey"
          title="How We Transform Industry Operations"
          description="Every digital transformation project follows a proven framework—from understanding your business to delivering measurable operational improvements."
        />

        <div className="mt-12 grid gap-4 lg:grid-cols-5">

          {steps.map((step, index) => {

            const Icon = step.icon;

            return (

              <div
                key={step.title}
                className="relative rounded-3xl border bg-card p-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >

                {index < steps.length - 1 && (

                  <div className="absolute left-full top-10 hidden h-px w-6 bg-border lg:block" />

                )}

                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10">

                  <Icon className="h-5 w-5 text-primary" />

                </div>

                <h3 className="mt-6 text-xl font-semibold">

                  {step.title}

                </h3>

                <p className="mt-4 leading-7 text-muted-foreground">

                  {step.description}

                </p>

              </div>

            );

          })}

        </div>
      </Container>
    </Section>
  );
}